import root from 'window-or-global';
import {generateRoutePath} from '@epic-core/common';
import {FeedCurrentFilterProps, FeedItemProps, FilterStore} from '../types';
import {AltLocPageData, getMessageFnType} from 'epic-ue-shared';
import {MultiCardOptionsArray} from 'epic-ue-ui';
import {getStardustItem} from './stardustUtils';

/**
 * Takes a url like /en-US/feed/all/enterprise+events and converts it into 2 separate maps for the filters
 * @param  {String} url
 * @return {Object}
 */

export function getFiltersFromUrl(url: string): FeedCurrentFilterProps {
    const types: null | FilterStore = {};
    const tags: null | FilterStore = {};

    if (!url || url.indexOf('/feed') === -1) return {types, tags};

    const parts = url.split('/feed/');

    if (parts.length > 1 && parts[1]) {
        const filter = parts[1];
        const filterParts = filter.split('/');
        if (filterParts[0]) {
            const typeParts = filterParts[0].split('+');
            typeParts.forEach((part) => {
                const cleanedType = decodeURIComponent(part)
                    .replace(/^\s+|\s+$|"/g, '')
                    .toLowerCase();
                types[cleanedType] = true;
            });
        }
        if (filterParts[1]) {
            const tagParts = filterParts[1].split('+');
            tagParts.forEach((part) => {
                const cleanedTag = decodeURIComponent(part)
                    .replace(/^\s+|\s+$|"/g, '')
                    .toLowerCase();
                tags[cleanedTag] = true;
            });
        }
    }

    delete types.all;
    delete tags.all;

    return {types, tags};
}

export function getSlugPath(item: FeedItemProps): string {
    return item._feedUrl;
}

export function objectsDiffer(
    currentObj: {[key: string]: any} | null,
    newObj: {[key: string]: any} | null
): boolean {
    let parsedCurrent: string[] = [];
    let parsedNew: string[] = [];

    if (currentObj) {
        for (const tag in currentObj) {
            if (Object.hasOwnProperty.call(currentObj, tag) && currentObj[tag]) {
                parsedCurrent.push(tag);
            }
        }
    }

    if (newObj) {
        for (const tag in newObj) {
            if (Object.hasOwnProperty.call(newObj, tag) && newObj[tag]) {
                parsedNew.push(tag);
            }
        }
    }

    if (parsedCurrent.length !== parsedNew.length) return true;

    parsedCurrent = parsedCurrent.sort();
    parsedNew = parsedNew.sort();

    for (let i = 0; i < parsedNew.length; i++) {
        if (parsedNew[i].toLowerCase() !== parsedCurrent[i].toLowerCase()) {
            return true;
        }
    }

    return false;
}

export function getImageUrl(item: FeedItemProps): string {
    return item.imageUrl;
}

export function getTitle(item: FeedItemProps): string {
    return item.title;
}

export function getShort(item: FeedItemProps): string {
    return item.description;
}

export function getLogo(item: FeedItemProps) {
    const {logo: stardustLogo} = getStardustItem(item);
    if (stardustLogo) return stardustLogo;

    if (item.logo) {
        return item.logo;
    }
}

export function getTagMatch(item: FeedItemProps): string[] | boolean {
    const {_feedTagMatch, _feedTags} = item;
    if (!_feedTagMatch) return false;

    const tagMatchList = _feedTagMatch as string[];

    const tagMatches: string[] = [];
    for (let i = 0; i < _feedTags.length; i++) {
        const tag = _feedTags[i].replace(/^\s+|\s+$|"/g, '');
        const lowerTag = tag && tag.toLowerCase();
        if (tagMatchList.length && tagMatchList.indexOf(lowerTag) > -1) {
            tagMatches.push(tag);
        }
    }

    return tagMatches;
}

interface ParsedUrl {
    query: {
        page?: number | string;
    };
    pathname: string;
}

export function getPageFromParsedUrl(parsedUrl: ParsedUrl): number {
    const query = parsedUrl.query || {};
    return +(query.page || 1);
}

export function getAltLocPageDataCards(
    feedItem: AltLocPageData,
    pageSlug: string,
    getMessage: getMessageFnType
): MultiCardOptionsArray {
    const {altLocPageData} = feedItem;
    const altLocPageCards: MultiCardOptionsArray = [];
    if (!altLocPageData) return altLocPageCards;

    for (let i = 0; i < altLocPageData.length; i++) {
        const data = altLocPageData[i];
        if (!data) continue;

        const handleClick = (e) => {
            e.preventDefault();
            root.location.href = generateRoutePath(
                `${pageSlug}?lang=${data && data._locale}`,
                true
            );
        };

        altLocPageCards.push({
            text: {
                eyebrow: {
                    text: getMessage('epic.enterprise.landing.news.text')
                },
                title: data._title,
                link: {
                    href: generateRoutePath(`${pageSlug}?lang=${data._locale}`, true),
                    label: getMessage(`epic.error.alt.404.read.locale.${data._locale}`)
                },
                onClick: handleClick
            }
        });
    }
    return altLocPageCards;
}
